module.exports = __webpack_public_path__ + "img/cur_rect.109982b7.png";